export default "__VITE_ASSET__6f6685f8__$_?component__"